import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import FullfillmentShipmentExcelImport from './FullfillmentShipmentExcelImport';

const FullfillmentShipment = ({ dispatch, vendor }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  return (
    <Container>
      {/* <Card className="pb-3">
        <CardBody className="dashboard__card-widget card-shadow p-3">
          <CardTitle className="bold-text text-center" tag="h3">
            Upload Order
          </CardTitle>          
        </CardBody>
      </Card> */}
      <Row className="product-table-wrap">        
          <Col sm="12">
            {/* <CardBody>    */}
                <FullfillmentShipmentExcelImport />          
            {/* </CardBody> */}
          </Col>     

      </Row>
    </Container>
  )
};

FullfillmentShipment.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vendor: PropTypes.number.isRequired
}

export default connect(state => ({
  rtl: state.rtl,
}))(FullfillmentShipment);